import { NgModule } from '@angular/core';
import { SharedModule } from "@app/shared";
import { MaterialModule } from '@app/shared/material.module';
import { BoundaryManagementModule } from '@modules/boundary-management/boundary-management.module';
import {
  AreaSetupParamsAddEditComponent, AreaSetupParmsListComponent, BoundaryApproverConfigAddEditComponent, BoundaryApproverConfigurationComponent, BoundaryManagementConfigurationRoutingModule, OpsManagementAddEditComponent, OpsManagementComponent
} from '@modules/others/configuration/components/boundary-management';
@NgModule({
  declarations: [OpsManagementComponent, OpsManagementAddEditComponent, AreaSetupParmsListComponent,
    AreaSetupParamsAddEditComponent, BoundaryApproverConfigurationComponent, BoundaryApproverConfigAddEditComponent],
  imports: [
    MaterialModule, SharedModule,
    BoundaryManagementConfigurationRoutingModule, BoundaryManagementModule
  ],
  entryComponents: [OpsManagementAddEditComponent, AreaSetupParamsAddEditComponent]
})

export class BoundaryManagementConfigurationModule { }
